module.exports = __webpack_public_path__ + "static/media/ratio.81d6becf.png";